import axios from 'axios';
import endpoints from './endpoints';

var headers = {}
if(localStorage.getItem("token") != null){
  headers = {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + localStorage.getItem("access_token")
  }
}


// Axios instance oluşturma
const axiosInstance = axios.create({
  baseURL: endpoints.base_url,
  timeout: 10000,
  headers: headers
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const { config, response } = error;
    const originalRequest = config;

    if (response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axiosInstance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const refreshToken = localStorage.getItem('refresh_token');
      return new Promise(function (resolve, reject) {


        const headers = {
          'Content-Type': 'application/json',
          'Authorization': "Bearer "  + refreshToken
        }

        axios.post(endpoints.base_url + endpoints.auth.refresh,{"grant_type": "refresh"}, {headers:headers}).then(({ data }) => {
          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('refresh_token', data.refresh_token);
          axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
          originalRequest.headers['Authorization'] = 'Bearer ' + data.access_token;
          processQueue(null, data.access_token);
          resolve(axiosInstance(originalRequest));
        }).catch((err) => {
          processQueue(err, null);
          if(err.response && err.response.status == 401){
            localStorage.clear()
            var _t = setTimeout(()=> {
              location.reload()
              clearTimeout(_t);
            }, 1000)
          }
          reject(err);
        }).then(() => {
          isRefreshing = false;
        });
      });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
